import { observable, computed, action } from 'mobx';

class User {

  @observable userId = ''
  @observable token = ''
  @observable wallet = {
    gold: {
      count: 0,
      tips: '',
      links: []
    },
    diamond: {
      count: 0,
      tips: '',
      links: []
    },
    role: 0,
    isBind: 0
  }

  @action setUserId = userId => {
    this.userId = userId
  }

  @action setToken = token => {
    this.token = token
  }

  @action setWallet = wallet => {
    ;(this.wallet.gold = wallet.gold), (this.wallet.diamond = wallet.diamond)
    this.wallet.role = wallet.role
    this.wallet.isBind = wallet.isBind
    this.wallet.isAliPayBind = wallet.isAliPayBind
    // this.account.gold = account.gold;
    // this.account.withdrawMoney = account.withdrawMoney;
    // this.account.giftPercent = account.giftPercent;
    // this.account.withdrawPercent = account.withdrawPercent;
  }

  @computed get getUserId() {
    return this.userId
  }

  @computed get getToken() {
    return this.token
  }

  @computed get getWallet() {
    return this.wallet
  }
}

export default User;
